import { useState, useEffect } from 'react';
import { getContrastTextColor, getBrandColor } from '@/lib/utils';

/**
 * Hook that returns the optimal text color based on the current brand color
 * @returns Object with text color and brand color
 */
export function useContrastText() {
  const [textColor, setTextColor] = useState<'white' | 'black'>('black');
  const [brandColor, setBrandColor] = useState<string>('#3b82f6');

  useEffect(() => {
    const updateColors = () => {
      const currentBrandColor = getBrandColor();
      const optimalTextColor = getContrastTextColor(currentBrandColor);
      
      setBrandColor(currentBrandColor);
      setTextColor(optimalTextColor);
    };

    // Initial update
    updateColors();

    // Listen for changes to CSS custom properties
    const observer = new MutationObserver(updateColors);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style']
    });

    // Also listen for window resize (in case of theme changes)
    window.addEventListener('resize', updateColors);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateColors);
    };
  }, []);

  return {
    textColor,
    brandColor,
    textColorClass: textColor === 'white' ? 'text-white' : 'text-black',
    // Utility function to get contrast color for any background
    getContrastForColor: getContrastTextColor
  };
} 
